// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { CreateTenancyInviteDTO } from '../models';
import { TenancyInviteDTO } from '../models';
import { UpdateTenancyInviteDTO } from '../models';
/**
 * TenancyInvitesApi - axios parameter creator
 * @export
 */
export const TenancyInvitesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Accept a tenancy invite
         * @param {string} token 
         * @param {boolean} clearSession 
         * @param {string} tenancyId Tenancy id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptTenancyInvite(token: string, clearSession: boolean, tenancyId: string, options: any = {}): RequestArgs {
            // verify required parameter 'token' is not null or undefined
            if (token === null || token === undefined) {
                throw new RequiredError('token','Required parameter token was null or undefined when calling acceptTenancyInvite.');
            }
            // verify required parameter 'clearSession' is not null or undefined
            if (clearSession === null || clearSession === undefined) {
                throw new RequiredError('clearSession','Required parameter clearSession was null or undefined when calling acceptTenancyInvite.');
            }
            // verify required parameter 'tenancyId' is not null or undefined
            if (tenancyId === null || tenancyId === undefined) {
                throw new RequiredError('tenancyId','Required parameter tenancyId was null or undefined when calling acceptTenancyInvite.');
            }
            const localVarPath = `/v2/tenancies/{tenancyId}/invites/accept`
                .replace(`{${"tenancyId"}}`, encodeURIComponent(String(tenancyId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }

            if (clearSession !== undefined) {
                localVarQueryParameter['clear_session'] = clearSession;
            }


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Invite a User to a Tenancy
         * @param {string} tenancyId Tenancy id
         * @param {CreateTenancyInviteDTO} createTenancyInviteDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTenancyInvite(tenancyId: string, createTenancyInviteDTO: CreateTenancyInviteDTO, options: any = {}): RequestArgs {
            // verify required parameter 'tenancyId' is not null or undefined
            if (tenancyId === null || tenancyId === undefined) {
                throw new RequiredError('tenancyId','Required parameter tenancyId was null or undefined when calling createTenancyInvite.');
            }
            // verify required parameter 'createTenancyInviteDTO' is not null or undefined
            if (createTenancyInviteDTO === null || createTenancyInviteDTO === undefined) {
                throw new RequiredError('createTenancyInviteDTO','Required parameter createTenancyInviteDTO was null or undefined when calling createTenancyInvite.');
            }
            const localVarPath = `/v2/tenancies/{tenancyId}/invites`
                .replace(`{${"tenancyId"}}`, encodeURIComponent(String(tenancyId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"CreateTenancyInviteDTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(createTenancyInviteDTO !== undefined ? createTenancyInviteDTO : {}) : (createTenancyInviteDTO || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a tenancy invite
         * @param {string} tenancyInviteId Tenancy Invite id
         * @param {string} tenancyId Tenancy id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTenancyInvite(tenancyInviteId: string, tenancyId: string, options: any = {}): RequestArgs {
            // verify required parameter 'tenancyInviteId' is not null or undefined
            if (tenancyInviteId === null || tenancyInviteId === undefined) {
                throw new RequiredError('tenancyInviteId','Required parameter tenancyInviteId was null or undefined when calling deleteTenancyInvite.');
            }
            // verify required parameter 'tenancyId' is not null or undefined
            if (tenancyId === null || tenancyId === undefined) {
                throw new RequiredError('tenancyId','Required parameter tenancyId was null or undefined when calling deleteTenancyInvite.');
            }
            const localVarPath = `/v2/tenancies/{tenancyId}/invites/{tenancyInviteId}`
                .replace(`{${"tenancyInviteId"}}`, encodeURIComponent(String(tenancyInviteId)))
                .replace(`{${"tenancyId"}}`, encodeURIComponent(String(tenancyId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a Tenancy\'s Invites
         * @param {string} tenancyId 
         * @param {string} organizationId Organization id
         * @param {boolean} [accepted] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchInvitesByTenancyId(tenancyId: string, organizationId: string, accepted?: boolean, options: any = {}): RequestArgs {
            // verify required parameter 'tenancyId' is not null or undefined
            if (tenancyId === null || tenancyId === undefined) {
                throw new RequiredError('tenancyId','Required parameter tenancyId was null or undefined when calling fetchInvitesByTenancyId.');
            }
            // verify required parameter 'organizationId' is not null or undefined
            if (organizationId === null || organizationId === undefined) {
                throw new RequiredError('organizationId','Required parameter organizationId was null or undefined when calling fetchInvitesByTenancyId.');
            }
            const localVarPath = `/v2/tenancies/{tenancyId}/invites`
                .replace(`{${"tenancyId"}}`, encodeURIComponent(String(tenancyId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (accepted !== undefined) {
                localVarQueryParameter['accepted'] = accepted;
            }


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Resend a tenancy invite for an existing unaccepted invite
         * @param {string} tenancyInviteId Tenancy Invite id
         * @param {string} tenancyId Tenancy id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendTenancyInvite(tenancyInviteId: string, tenancyId: string, options: any = {}): RequestArgs {
            // verify required parameter 'tenancyInviteId' is not null or undefined
            if (tenancyInviteId === null || tenancyInviteId === undefined) {
                throw new RequiredError('tenancyInviteId','Required parameter tenancyInviteId was null or undefined when calling resendTenancyInvite.');
            }
            // verify required parameter 'tenancyId' is not null or undefined
            if (tenancyId === null || tenancyId === undefined) {
                throw new RequiredError('tenancyId','Required parameter tenancyId was null or undefined when calling resendTenancyInvite.');
            }
            const localVarPath = `/v2/tenancies/{tenancyId}/invites/{tenancyInviteId}/resend`
                .replace(`{${"tenancyInviteId"}}`, encodeURIComponent(String(tenancyInviteId)))
                .replace(`{${"tenancyId"}}`, encodeURIComponent(String(tenancyId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a tenancy invite
         * @param {string} tenancyInviteId Tenancy Invite id
         * @param {string} tenancyId Tenancy id
         * @param {UpdateTenancyInviteDTO} updateTenancyInviteDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTenancyInvite(tenancyInviteId: string, tenancyId: string, updateTenancyInviteDTO: UpdateTenancyInviteDTO, options: any = {}): RequestArgs {
            // verify required parameter 'tenancyInviteId' is not null or undefined
            if (tenancyInviteId === null || tenancyInviteId === undefined) {
                throw new RequiredError('tenancyInviteId','Required parameter tenancyInviteId was null or undefined when calling updateTenancyInvite.');
            }
            // verify required parameter 'tenancyId' is not null or undefined
            if (tenancyId === null || tenancyId === undefined) {
                throw new RequiredError('tenancyId','Required parameter tenancyId was null or undefined when calling updateTenancyInvite.');
            }
            // verify required parameter 'updateTenancyInviteDTO' is not null or undefined
            if (updateTenancyInviteDTO === null || updateTenancyInviteDTO === undefined) {
                throw new RequiredError('updateTenancyInviteDTO','Required parameter updateTenancyInviteDTO was null or undefined when calling updateTenancyInvite.');
            }
            const localVarPath = `/v2/tenancies/{tenancyId}/invites/{tenancyInviteId}`
                .replace(`{${"tenancyInviteId"}}`, encodeURIComponent(String(tenancyInviteId)))
                .replace(`{${"tenancyId"}}`, encodeURIComponent(String(tenancyId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"UpdateTenancyInviteDTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(updateTenancyInviteDTO !== undefined ? updateTenancyInviteDTO : {}) : (updateTenancyInviteDTO || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TenancyInvitesApi - functional programming interface
 * @export
 */
export const TenancyInvitesApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Accept a tenancy invite
         * @param {string} token 
         * @param {boolean} clearSession 
         * @param {string} tenancyId Tenancy id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptTenancyInvite(token: string, clearSession: boolean, tenancyId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<object> {
            const localVarAxiosArgs = TenancyInvitesApiAxiosParamCreator(configuration).acceptTenancyInvite(token, clearSession, tenancyId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Invite a User to a Tenancy
         * @param {string} tenancyId Tenancy id
         * @param {CreateTenancyInviteDTO} createTenancyInviteDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTenancyInvite(tenancyId: string, createTenancyInviteDTO: CreateTenancyInviteDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<object> {
            const localVarAxiosArgs = TenancyInvitesApiAxiosParamCreator(configuration).createTenancyInvite(tenancyId, createTenancyInviteDTO, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Delete a tenancy invite
         * @param {string} tenancyInviteId Tenancy Invite id
         * @param {string} tenancyId Tenancy id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTenancyInvite(tenancyInviteId: string, tenancyId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<object> {
            const localVarAxiosArgs = TenancyInvitesApiAxiosParamCreator(configuration).deleteTenancyInvite(tenancyInviteId, tenancyId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get a Tenancy\'s Invites
         * @param {string} tenancyId 
         * @param {string} organizationId Organization id
         * @param {boolean} [accepted] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchInvitesByTenancyId(tenancyId: string, organizationId: string, accepted?: boolean, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TenancyInviteDTO>> {
            const localVarAxiosArgs = TenancyInvitesApiAxiosParamCreator(configuration).fetchInvitesByTenancyId(tenancyId, organizationId, accepted, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Resend a tenancy invite for an existing unaccepted invite
         * @param {string} tenancyInviteId Tenancy Invite id
         * @param {string} tenancyId Tenancy id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendTenancyInvite(tenancyInviteId: string, tenancyId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<object> {
            const localVarAxiosArgs = TenancyInvitesApiAxiosParamCreator(configuration).resendTenancyInvite(tenancyInviteId, tenancyId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Update a tenancy invite
         * @param {string} tenancyInviteId Tenancy Invite id
         * @param {string} tenancyId Tenancy id
         * @param {UpdateTenancyInviteDTO} updateTenancyInviteDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTenancyInvite(tenancyInviteId: string, tenancyId: string, updateTenancyInviteDTO: UpdateTenancyInviteDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenancyInviteDTO> {
            const localVarAxiosArgs = TenancyInvitesApiAxiosParamCreator(configuration).updateTenancyInvite(tenancyInviteId, tenancyId, updateTenancyInviteDTO, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * TenancyInvitesApi - factory interface
 * @export
 */
export const TenancyInvitesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Accept a tenancy invite
         * @param {string} token 
         * @param {boolean} clearSession 
         * @param {string} tenancyId Tenancy id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptTenancyInvite(token: string, clearSession: boolean, tenancyId: string, options?: any) {
            return TenancyInvitesApiFp(configuration).acceptTenancyInvite(token, clearSession, tenancyId, options)(axios, basePath);
        },
        /**
         * Invite a User to a Tenancy
         * @param {string} tenancyId Tenancy id
         * @param {CreateTenancyInviteDTO} createTenancyInviteDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTenancyInvite(tenancyId: string, createTenancyInviteDTO: CreateTenancyInviteDTO, options?: any) {
            return TenancyInvitesApiFp(configuration).createTenancyInvite(tenancyId, createTenancyInviteDTO, options)(axios, basePath);
        },
        /**
         * Delete a tenancy invite
         * @param {string} tenancyInviteId Tenancy Invite id
         * @param {string} tenancyId Tenancy id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTenancyInvite(tenancyInviteId: string, tenancyId: string, options?: any) {
            return TenancyInvitesApiFp(configuration).deleteTenancyInvite(tenancyInviteId, tenancyId, options)(axios, basePath);
        },
        /**
         * Get a Tenancy\'s Invites
         * @param {string} tenancyId 
         * @param {string} organizationId Organization id
         * @param {boolean} [accepted] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchInvitesByTenancyId(tenancyId: string, organizationId: string, accepted?: boolean, options?: any) {
            return TenancyInvitesApiFp(configuration).fetchInvitesByTenancyId(tenancyId, organizationId, accepted, options)(axios, basePath);
        },
        /**
         * Resend a tenancy invite for an existing unaccepted invite
         * @param {string} tenancyInviteId Tenancy Invite id
         * @param {string} tenancyId Tenancy id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendTenancyInvite(tenancyInviteId: string, tenancyId: string, options?: any) {
            return TenancyInvitesApiFp(configuration).resendTenancyInvite(tenancyInviteId, tenancyId, options)(axios, basePath);
        },
        /**
         * Update a tenancy invite
         * @param {string} tenancyInviteId Tenancy Invite id
         * @param {string} tenancyId Tenancy id
         * @param {UpdateTenancyInviteDTO} updateTenancyInviteDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTenancyInvite(tenancyInviteId: string, tenancyId: string, updateTenancyInviteDTO: UpdateTenancyInviteDTO, options?: any) {
            return TenancyInvitesApiFp(configuration).updateTenancyInvite(tenancyInviteId, tenancyId, updateTenancyInviteDTO, options)(axios, basePath);
        },
    };
};

/**
 * TenancyInvitesApi - interface
 * @export
 * @interface TenancyInvitesApi
 */
export interface TenancyInvitesApiInterface {
    /**
     * Accept a tenancy invite
     * @param {string} token 
     * @param {boolean} clearSession 
     * @param {string} tenancyId Tenancy id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenancyInvitesApiInterface
     */
    acceptTenancyInvite(token: string, clearSession: boolean, tenancyId: string, options?: any): AxiosPromise<object>;

    /**
     * Invite a User to a Tenancy
     * @param {string} tenancyId Tenancy id
     * @param {CreateTenancyInviteDTO} createTenancyInviteDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenancyInvitesApiInterface
     */
    createTenancyInvite(tenancyId: string, createTenancyInviteDTO: CreateTenancyInviteDTO, options?: any): AxiosPromise<object>;

    /**
     * Delete a tenancy invite
     * @param {string} tenancyInviteId Tenancy Invite id
     * @param {string} tenancyId Tenancy id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenancyInvitesApiInterface
     */
    deleteTenancyInvite(tenancyInviteId: string, tenancyId: string, options?: any): AxiosPromise<object>;

    /**
     * Get a Tenancy\'s Invites
     * @param {string} tenancyId 
     * @param {string} organizationId Organization id
     * @param {boolean} [accepted] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenancyInvitesApiInterface
     */
    fetchInvitesByTenancyId(tenancyId: string, organizationId: string, accepted?: boolean, options?: any): AxiosPromise<Array<TenancyInviteDTO>>;

    /**
     * Resend a tenancy invite for an existing unaccepted invite
     * @param {string} tenancyInviteId Tenancy Invite id
     * @param {string} tenancyId Tenancy id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenancyInvitesApiInterface
     */
    resendTenancyInvite(tenancyInviteId: string, tenancyId: string, options?: any): AxiosPromise<object>;

    /**
     * Update a tenancy invite
     * @param {string} tenancyInviteId Tenancy Invite id
     * @param {string} tenancyId Tenancy id
     * @param {UpdateTenancyInviteDTO} updateTenancyInviteDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenancyInvitesApiInterface
     */
    updateTenancyInvite(tenancyInviteId: string, tenancyId: string, updateTenancyInviteDTO: UpdateTenancyInviteDTO, options?: any): AxiosPromise<TenancyInviteDTO>;

}

/**
 * TenancyInvitesApi - object-oriented interface
 * @export
 * @class TenancyInvitesApi
 * @extends {BaseAPI}
 */
export class TenancyInvitesApi extends BaseAPI implements TenancyInvitesApiInterface {
    /**
     * Accept a tenancy invite
     * @param {string} token 
     * @param {boolean} clearSession 
     * @param {string} tenancyId Tenancy id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenancyInvitesApi
     */
    public acceptTenancyInvite(token: string, clearSession: boolean, tenancyId: string, options?: any) {
        return TenancyInvitesApiFp(this.configuration).acceptTenancyInvite(token, clearSession, tenancyId, options)(this.axios, this.basePath);
    }

    /**
     * Invite a User to a Tenancy
     * @param {string} tenancyId Tenancy id
     * @param {CreateTenancyInviteDTO} createTenancyInviteDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenancyInvitesApi
     */
    public createTenancyInvite(tenancyId: string, createTenancyInviteDTO: CreateTenancyInviteDTO, options?: any) {
        return TenancyInvitesApiFp(this.configuration).createTenancyInvite(tenancyId, createTenancyInviteDTO, options)(this.axios, this.basePath);
    }

    /**
     * Delete a tenancy invite
     * @param {string} tenancyInviteId Tenancy Invite id
     * @param {string} tenancyId Tenancy id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenancyInvitesApi
     */
    public deleteTenancyInvite(tenancyInviteId: string, tenancyId: string, options?: any) {
        return TenancyInvitesApiFp(this.configuration).deleteTenancyInvite(tenancyInviteId, tenancyId, options)(this.axios, this.basePath);
    }

    /**
     * Get a Tenancy\'s Invites
     * @param {string} tenancyId 
     * @param {string} organizationId Organization id
     * @param {boolean} [accepted] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenancyInvitesApi
     */
    public fetchInvitesByTenancyId(tenancyId: string, organizationId: string, accepted?: boolean, options?: any) {
        return TenancyInvitesApiFp(this.configuration).fetchInvitesByTenancyId(tenancyId, organizationId, accepted, options)(this.axios, this.basePath);
    }

    /**
     * Resend a tenancy invite for an existing unaccepted invite
     * @param {string} tenancyInviteId Tenancy Invite id
     * @param {string} tenancyId Tenancy id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenancyInvitesApi
     */
    public resendTenancyInvite(tenancyInviteId: string, tenancyId: string, options?: any) {
        return TenancyInvitesApiFp(this.configuration).resendTenancyInvite(tenancyInviteId, tenancyId, options)(this.axios, this.basePath);
    }

    /**
     * Update a tenancy invite
     * @param {string} tenancyInviteId Tenancy Invite id
     * @param {string} tenancyId Tenancy id
     * @param {UpdateTenancyInviteDTO} updateTenancyInviteDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenancyInvitesApi
     */
    public updateTenancyInvite(tenancyInviteId: string, tenancyId: string, updateTenancyInviteDTO: UpdateTenancyInviteDTO, options?: any) {
        return TenancyInvitesApiFp(this.configuration).updateTenancyInvite(tenancyInviteId, tenancyId, updateTenancyInviteDTO, options)(this.axios, this.basePath);
    }

}

/**
 * Standalone tree-shakeable functions for TenancyInvitesApi
 * Import individual functions for optimal bundle size
 */
/**
 * Accept a tenancy invite
 * @param {string} token 
 * @param {boolean} clearSession 
 * @param {string} tenancyId Tenancy id
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function acceptTenancyInvite(
    token: string,
    clearSession: boolean,
    tenancyId: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<object> {
    const localVarAxiosArgs = TenancyInvitesApiAxiosParamCreator(configuration).acceptTenancyInvite(token, clearSession, tenancyId, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Invite a User to a Tenancy
 * @param {string} tenancyId Tenancy id
 * @param {CreateTenancyInviteDTO} createTenancyInviteDTO 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function createTenancyInvite(
    tenancyId: string,
    createTenancyInviteDTO: CreateTenancyInviteDTO,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<object> {
    const localVarAxiosArgs = TenancyInvitesApiAxiosParamCreator(configuration).createTenancyInvite(tenancyId, createTenancyInviteDTO, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Delete a tenancy invite
 * @param {string} tenancyInviteId Tenancy Invite id
 * @param {string} tenancyId Tenancy id
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function deleteTenancyInvite(
    tenancyInviteId: string,
    tenancyId: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<object> {
    const localVarAxiosArgs = TenancyInvitesApiAxiosParamCreator(configuration).deleteTenancyInvite(tenancyInviteId, tenancyId, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Get a Tenancy\'s Invites
 * @param {string} tenancyId 
 * @param {string} organizationId Organization id
 * @param {boolean} [accepted] 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function fetchInvitesByTenancyId(
    tenancyId: string,
    organizationId: string,
    accepted?: boolean,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<Array<TenancyInviteDTO>> {
    const localVarAxiosArgs = TenancyInvitesApiAxiosParamCreator(configuration).fetchInvitesByTenancyId(tenancyId, organizationId, accepted, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Resend a tenancy invite for an existing unaccepted invite
 * @param {string} tenancyInviteId Tenancy Invite id
 * @param {string} tenancyId Tenancy id
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function resendTenancyInvite(
    tenancyInviteId: string,
    tenancyId: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<object> {
    const localVarAxiosArgs = TenancyInvitesApiAxiosParamCreator(configuration).resendTenancyInvite(tenancyInviteId, tenancyId, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Update a tenancy invite
 * @param {string} tenancyInviteId Tenancy Invite id
 * @param {string} tenancyId Tenancy id
 * @param {UpdateTenancyInviteDTO} updateTenancyInviteDTO 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function updateTenancyInvite(
    tenancyInviteId: string,
    tenancyId: string,
    updateTenancyInviteDTO: UpdateTenancyInviteDTO,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<TenancyInviteDTO> {
    const localVarAxiosArgs = TenancyInvitesApiAxiosParamCreator(configuration).updateTenancyInvite(tenancyInviteId, tenancyId, updateTenancyInviteDTO, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

